<template>
  <div class="zj-layout-main-content bgcolor scrollable" style="overflow: auto">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="110px"
      v-loading="loading"
      :element-loading-text="loadingText"
    >
      <zj-layout-container>
        <zj-layout-header>
          <div class="listtitle">设备详情</div>
        </zj-layout-header>
      </zj-layout-container>
      <!-- prop="ResourceName" -->
      <zj-layout-main>
        <el-form
          ref="form"
          :model="data"
          :rules="rules"
          label-width="16rem"
          style="width: 80%"
        >
          <el-row>
            <el-col :span="12">
              <el-form-item label="设备名称" prop="Name">
                <el-input v-model="data.Name" :disabled="!IsEdit"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="设备简称" prop="ShortName">
                <el-input
                  v-model="data.ShortName"
                  :disabled="!IsEdit"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="设备类型" prop="EquType">
                <el-select
                  v-model="data.EquType"
                  placeholder="请选择"
                  style="width: 100%"
                  :disabled="!IsEdit"
                >
                  <el-option
                    v-for="item in EquTypeArr"
                    :key="item.ItemKey"
                    :label="item.Description"
                    :value="item.ItemValue"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="设备编号" prop="SerialNumber">
                <el-input
                  v-model="data.SerialNumber"
                  :disabled="!IsEdit"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="用户名" prop="EquLogonName">
                <el-input
                  v-model="data.EquLogonName"
                  :disabled="!IsEdit"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="密码" prop="EquLogonPassword">
                <el-input
                  v-model="data.EquLogonPassword"
                  :disabled="!IsEdit"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="IP地址" prop="IP">
                <el-input
                  v-model="data.IP"
                  :disabled="!IsEdit"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="端口号" prop="Port">
                <el-input
                  v-model="data.Port"
                  :disabled="!IsEdit"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="经度" prop="Longitude">
                <el-input
                  v-model="data.Longitude"
                  :disabled="!IsEdit"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="11">
              <el-form-item label="纬度" prop="Latitude">
                <el-input
                  v-model="data.Latitude"
                  :disabled="!IsEdit"
                ></el-input>
              </el-form-item>
            </el-col>
            <ZjLngLatSelect
              class="newtaskposition"
              :point_lat="data.Latitude"
              :point_lng="data.Longitude"
              @onGotLngLat="onGotLngLat"
            ></ZjLngLatSelect>
          </el-row>
          <el-row>
          
            <el-col :span="24">
              <el-form-item label="备注" prop="Description">
                <el-input
                  v-model="data.Description"
                  :disabled="!IsEdit"
                  type="textarea"
                  :autosize="{ minRows: 2 }"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </zj-layout-main>
      <el-form-item class="right" style="width: 134rem">
        <el-button @click="onBack()">返回</el-button>
        <el-button
          type="primary"
          @click="saveForm()"
          :disabled="!IsEdit"
          v-if="IsEdit"
          >保存</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import MyApis from "../../../apis";
import ZJApp from "../../../../../app";

export default {
  name: "EquipmentInfo",
  controller: "UI",
  action: "EquipmentInfo",
  data() {
    return {
      data: {
        EquType: "",
        Latitude: "",
        Longitude: "",
      },
      EquTypeArr: [],
      IsEdit: false,
      rules: {
        Name: [
          { required: true, message: "请输入设备名称", trigger: "blur" },
        ],
        EquType: [
          { required: true, message: "请选择设备类型", trigger: "change" },
        ],
        IP: [
          { required: true, message: "请输入IP地址", trigger: "blur" },
        ],
        Longitude: [
          {
            required: false,
            message: "请输入有效的经度",
            trigger: "blur",
            pattern: /^(-?[0-9]+)(\.[0-9]+)?$/,
          },
        ],
        Latitude: [
          {
            required: false,
            message: "请输入有效的纬度",
            trigger: "blur",
            pattern: /^(-?[0-9]+)(\.[0-9]+)?$/,
          },
        ],
      },
      loading: false,
      loadingText: "加载中...",
    };
  },
  created: function () {
    if (this.$route.query.InfoId) {
      this.search();
    }
    if (this.$route.query.type == "query") {
      this.IsEdit = false;
    } else {
      this.IsEdit = true;
    }
    //区域
    this.getEquType();
  },
  watch: {
    $route: function () {
      if (this.$route.query.InfoId) {
        this.search();
      }
    },
  },
  methods: {
    getEquType() {
      this.config
        .getUValue("EquMonitorSubSystem:EquType", "")
        .then((d) => {
          this.EquTypeArr = d.JValue;
        })
        .catch((e) => console.error(e));
    },
    onGotLngLat(obj) {
      this.data.Latitude = obj.lat || 0;
      this.data.Longitude = obj.lng || 0;
    },
    search() {
      let InfoId = this.$route.query.InfoId;
      if (InfoId) {
        new MyApis.TranResourcesApi()
          .FindEquipmentById({ ID: InfoId })
          .then((r) => {
            r = r.data.Data;
            console.log(r);
            this.data = r;
          })
          .catch((e) => {
            console.log(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
      }
    },
    //返回按钮
    onBack() {
      this.$router.go(-1); //返回上一层
    },
    //保存
    saveForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.saveData();
        } else {
          return false;
        }
      });
    },
    saveData() {
      this.loading = true;
      this.loadingText = "保存中...";
      let uuid = "";
      if (this.$route.query.type == "edit") {
        uuid = this.$route.query.InfoId;
      } else {
        uuid = ZJApp.ZJUtils.uuid();
      }
      if (this.data.EquType != null && this.data.EquType != "") {
        const EquTypeName = this.EquTypeArr.filter((item) => {
          return item.ItemValue === this.data.EquType;
        });
        this.data.EquTypeName = EquTypeName[0].Description;
      }
      if (this.$route.query.type == "edit") {
        //编辑
        this.data.ModifyTime = new Date();
        this.data.Modifier = ZJApp.ZJUser.current.UserName;
        let formAll = JSON.stringify(this.data);
        formAll = JSON.parse(formAll);
        new MyApis.TranResourcesApi()
          .UpdateEquipment(formAll)
          .then((r) => {
            r = r.data.Data;
            this.$message({
              type: "success",
              message: r ? "保存成功！" : "保存失败！",
            });
            this.logInfo.ActionName = "设备信息修改";
            this.logInfo.LogMessage = r
              ? "设备信息修改成功"
              : "设备信息修改失败";
            this.logInfo.ModuleName = "设备资源监控";
            this.logInfo.PageName = "设备详情";
            this.addOperationLog();
            this.loading = false;
            this.$router.go(-1); //返回上一层
          })
          .catch((e) => {
            console.log(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
      } else {
        // 增加
        let formObj = {
          Creater: ZJApp.ZJUser.current.UserName,
          CreateTime: new Date(),
          Modifier: ZJApp.ZJUser.current.UserName,
          ModifyTime: new Date(),
          DeviceId: uuid,
          Validity: 1, //新增编辑是1，删除是0
        };
        let formAll = Object.assign(formObj, this.data);
        formAll = JSON.stringify(formAll);
        formAll = JSON.parse(formAll);
        new MyApis.TranResourcesApi()
          .InsertEquipment(formAll)
          .then((r) => {
            r = r.data.Data;
            this.$message({
              type: "success",
              message: r ? "保存成功！" : "保存失败！",
            });
            this.logInfo.ActionName = "设备信息添加";
            this.logInfo.LogMessage = r
              ? "设备信息添加成功"
              : "设备信息添加失败";
            this.logInfo.ModuleName = "设备资源监控";
            this.logInfo.PageName = "设备详情";
            this.addOperationLog();
            this.loading = false;
            this.$router.go(-1); //返回上一层
          })
          .catch((e) => {
            console.log(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
      }
    },
  },
};
</script>
